import React, { useEffect } from 'react';
import SelectTurnType from '../SelectTurnType/SelectTurnType';
import CheckPrefrences from '../CheckPrefrences/CheckPrefrences';
import AgreementHTMLEditor from '../AgreementHTMLEditor/AgreementHTMLEditor';

const ElementMatcher = ({
  field,
  onChange,
  agreement_rules_title,
  submitButton_width,
}) => {
  const width = submitButton_width;

  useEffect(() => {
    const qlContainer =
      document.querySelector('.ql-container');
    const qlTitle = document.querySelector('.ql-toolbar');
    if (qlContainer) {
      qlContainer.style.width = `${width - 3}px`;
    }
    if (qlTitle) {
      qlTitle.style.width = `${width - 3}px`;
    }
  }, [width]);

  // console.log('field====>', field);

  // console.log('field===>', field);

  return (
    <React.Fragment>
      {field?.TypeValue !== null ? (
        field?.TypeValue === 'int' ? (
          <SelectTurnType
            field={field}
            onChange={onChange}
          />
        ) : field?.TypeValue === 'bool' ? (
          <CheckPrefrences
            field={field}
            onChange={onChange}
          />
        ) : field?.TypeValue === 'string' ? (
          <AgreementHTMLEditor
            field={field}
            onChange={onChange}
            agreement_rules_title={agreement_rules_title}
          />
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default ElementMatcher;
